import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.js\",\"import\":\"Inter\",\"arguments\":[{\"weight\":[\"200\",\"300\",\"400\",\"700\",\"800\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"mainFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Provider"] */ "/vercel/path0/providers/chakra.js");
